// IMPORTACIÓN DE PAQUETE
import firebase from 'firebase/app'
import 'firebase/storage';

// REQUERIMIENTOS
require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");
require("firebase/functions");
require("firebase/analytics");

// FIREBASE APP CONFIGURACIÓN
var firebaseConfig = {
    apiKey: "AIzaSyBOy8Yuiq9tSm5da4SdVgGJX2n6o10IGQo",
    authDomain: "iper-matriz.firebaseapp.com",
    databaseURL: "https://iper-matriz.firebaseio.com",
    projectId: "iper-matriz",
    storageBucket: "iper-matriz.appspot.com",
    messagingSenderId: "274403833027",
    appId: "1:274403833027:web:81ec31280506cd7a"
};

// INICIALIZA FIREBASE 
firebase.initializeApp(firebaseConfig);
firebase.analytics();

// Obtener una referencia al servicio de almacenamiento
// const storage = app.storage();

// PARÁMETROS
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();
const functions = firebase.functions();

// EXPORTACIÓN DE PARÁMETROS
export {
    firebase,
    auth,
    db,
    storage,
    functions
}

// GUÍAS

// CONSULTAR DATOS - SOLO UNA VEZ
// db.collection("cities").where("capital", "==", true)
// .get()
// .then(function(querySnapshot) {
//     querySnapshot.forEach(function(doc) {
//         // doc.data() is never undefined for query doc snapshots
//         console.log(doc.id, " => ", doc.data());
//     });
// })
// .catch(function(error) {
//     console.log("Error getting documents: ", error);
// });